/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HtmlPageConfigPageTypeRespVo
 */
export interface HtmlPageConfigPageTypeRespVo {
    /**
     * 
     * @type {number}
     * @memberof HtmlPageConfigPageTypeRespVo
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof HtmlPageConfigPageTypeRespVo
     */
    name?: string;
}

/**
 * Check if a given object implements the HtmlPageConfigPageTypeRespVo interface.
 */
export function instanceOfHtmlPageConfigPageTypeRespVo(value: object): value is HtmlPageConfigPageTypeRespVo {
    return true;
}

export function HtmlPageConfigPageTypeRespVoFromJSON(json: any): HtmlPageConfigPageTypeRespVo {
    return HtmlPageConfigPageTypeRespVoFromJSONTyped(json, false);
}

export function HtmlPageConfigPageTypeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HtmlPageConfigPageTypeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function HtmlPageConfigPageTypeRespVoToJSON(json: any): HtmlPageConfigPageTypeRespVo {
    return HtmlPageConfigPageTypeRespVoToJSONTyped(json, false);
}

export function HtmlPageConfigPageTypeRespVoToJSONTyped(value?: HtmlPageConfigPageTypeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

